import ActiveFilters from '@dc/ui-library/src/organisms/ActiveFilters/ActiveFilters';
import Icon from '@dc/ui-library/src/molecules/Icon/Icon';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Filter from './Filter';
import FilterPriceRange from './FilterPriceRange';
import FilterLocationSearch from './presentionalComponents/FilterLocationSearch';
import { resetAllFilters, toggleCheckboxOption }
  from '../../../../../appState/ducks/listingPageFilters';
import {
  filterTypes, hasActiveFilter, isFilterActive,
  transformForActiveFilters
} from './filterHelpers';
import { filtersPropTypes } from './propTypes';
import renderLink from './presentionalComponents/LinkWrapper';

let showSpinner = false;

function FiltersContainerDesktop(props) {
  if (!props.pendingProductsRequest) {
    showSpinner = false;
  }

  function renderFiltersList(filters) {
    return filters.map((filter, count) => {
      if (filter.isFoldedByDefault === false || isFilterActive(filter)) {
        filter = {
          ...filter,
          openedFilter: true
        };
      }

      if (filter.type === filterTypes.price) {
        return (
          <FilterPriceRange
            key={filter.name}
            {...filter}
          />
        );
      }

      if (filter.type === filterTypes.location) {
        return (
          <Filter
            key={filter.name}
            deviceType={props.deviceType}
            {...filter}
          >
            {props.locationServiceLoaded && props.locationSearchEnabled &&
            <FilterLocationSearch />}
          </Filter>
        );
      }

      return (
        <Filter
          key={filter.name}
          deviceType={props.deviceType}
          {...filter}
        />
      );
    });
  }

  function resetAllActiveFilters() {
    showSpinner = true;
    props.resetAllFilters();
  }

  function onRemoveActiveFilter(data) {
    showSpinner = true;
    props.toggleCheckboxOption({
      ...data,
      fetchNewData: true
    });
  }

  return (
    <div
      className={'dc-filter-container'}
      data-is-loading={props.pendingProductsRequest}
    >
      {props.pendingProductsRequest && (
      <div className={'dc-filter-container__loader'}>
        {showSpinner && (
        <Icon
          icon={'Spinner'}
          style={{
            position: 'absolute',
            zIndex: 4,
            top: '50px'
          }}
          spin
        />
        )}
      </div>
      )}

      {hasActiveFilter(props) && (
      <ActiveFilters
        resetFilters={resetAllActiveFilters}
        handleRemoveFilter={onRemoveActiveFilter}
        filters={transformForActiveFilters(props.filters)}
        filterTypes={filterTypes}
        displayResetButton
      />
      )}
      <header className={'dc-filter-container__header'}>
        <span className={'dc-active-filters__title'}>Filter by:</span>
      </header>
      <div>
        {props.tariff && renderLink(props.tariff, 'desktop')}
        {renderFiltersList(props.filters)}
      </div>
    </div>
  );
}

FiltersContainerDesktop.displayName = 'FiltersContainerDesktop';

FiltersContainerDesktop.propTypes = {
  tariff: PropTypes.shape(),
  resetAllFilters: PropTypes.func,
  toggleCheckboxOption: PropTypes.func,
  deviceType: PropTypes.oneOf(['wide', 'desktop', 'tablet', 'mobile']).isRequired,
  pendingProductsRequest: PropTypes.bool,
  filters: filtersPropTypes.isRequired,
  locationServiceLoaded: PropTypes.bool,
  locationSearchEnabled: PropTypes.bool
};

FiltersContainerDesktop.defaultProps = {
  tariff: null,
  resetAllFilters: () => {},
  toggleCheckboxOption: () => {},
  pendingProductsRequest: false,
  locationServiceLoaded: false,
  locationSearchEnabled: false
};

function mapStateToProps(state) {
  return {
    pendingProductsRequest: state.listingPage.pageSetup.xhrStatus.pendingProductsRequest,
    locationServiceLoaded: !state.listingPage.locationSearch.locationServiceLoading,
    locationSearchEnabled: state.listingPage.pageSetup.islocationSearchEnabled
  };
}

const dispatchFunction = { resetAllFilters, toggleCheckboxOption };

export default connect(mapStateToProps, dispatchFunction)(FiltersContainerDesktop);
